import { render, staticRenderFns } from "./StartSurvey.vue?vue&type=template&id=42356651&scoped=true&"
import script from "./StartSurvey.vue?vue&type=script&lang=js&"
export * from "./StartSurvey.vue?vue&type=script&lang=js&"
import style0 from "./StartSurvey.vue?vue&type=style&index=0&id=42356651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42356651",
  null
  
)

export default component.exports